import { OrganizationSource } from '@alkem/lib-front-model';

/** @deprecated use OrganizationSource from @alkem/lib-front-model */
export const SOURCE_ALKEMICS = OrganizationSource.ALKEMICS;
/** @deprecated use OrganizationSource from @alkem/lib-front-model */
export const SOURCE_PRODUCTDNA = OrganizationSource.PRODUCTDNA;
